const strings = {
	en: {
		description: {
			1: "Enter an email and we'll send you a code to reset your password",
			2: 'Enter the code that we have sent to your email in order to reset your password',
			3: 'Enter your new password',
		},
		label: {
			1: 'Email',
			2: 'Code',
			3: 'New Password',
		},
		button: {
			1: 'Send Code',
			2: 'Verify Code',
			3: 'Change Password',
		},
		alertTitle: 'Success',
		alertText: 'Password changed correctly',
		title: 'Reset Password',
		missing: 'Your password is missing:',
	},
	es: {
		description: {
			1: 'Ingresa tu correo y te enviaremos un código para restablecer tu contraseña',
			2: 'Ingresa el código que hemos enviado a tu correo para restablecer tu contraseña',
			3: 'Ingresa tu nueva contraseña',
		},
		label: {
			1: 'Correo',
			2: 'Código',
			3: 'Nueva contraseña',
		},
		button: {
			1: 'Enviar código',
			2: 'Comprobar código',
			3: 'Cambiar contraseña',
		},
		alertTitle: 'Éxito',
		alertText: 'Contraseña restablecida correctamente',
		title: 'Cambiar contraseña',
		missing: 'A tu contraseña le falta:',
	},
};

export default strings;
